import { useState } from "react";
import { useNavigate } from "react-router-dom";

const policies = [
  {
    id: "IN20250410001",
    title: "旅行综合意外险",
    order: "三亚5天4晚套餐",
    orderId: "M20250413001",
    insurer: "中国人民财产保险股份有限公司",
    policyNo: "PICC2025050100012",
    premium: "¥68",
    coveragePeriod: "2025-05-01 ~ 2025-05-05",
    purchaseDate: "2025-04-10",
    status: "生效中",
    statusColor: "#10B981",
    statusBg: "#F0FDF4",
    insured: [
      { name: "林晓雨", idCard: "310***1234", phone: "138****8888", relation: "本人" },
      { name: "林大明", idCard: "310***5678", phone: "138****9999", relation: "配偶" },
    ],
    coverages: [
      { name: "意外身故/残疾", amount: "100万元", desc: "因意外事故导致身故或伤残" },
      { name: "意外医疗", amount: "20万元", desc: "因意外事故产生的医疗费用" },
      { name: "旅行取消", amount: "5,000元", desc: "因不可抗力导致行程取消" },
      { name: "行李延误/丢失", amount: "3,000元", desc: "行李延误或丢失的赔偿" },
      { name: "紧急救援", amount: "不限额", desc: "24小时紧急医疗救援服务" },
    ],
    claimContact: "400-888-8888",
    claimProcess: ["拨打理赔热线或APP申请", "提交相关证明材料", "24小时内审核反馈", "3个工作日内赔付"],
    emergencyContact: "全球紧急救援：+86-400-888-8888",
  },
  {
    id: "IN20250312001",
    title: "旅行取消险",
    order: "大理古城3日游",
    orderId: "S20250401002",
    insurer: "中国太平洋财产保险股份有限公司",
    policyNo: "CPIC2025031500023",
    premium: "¥28",
    coveragePeriod: "2025-03-15 ~ 2025-03-18",
    purchaseDate: "2025-03-12",
    status: "已过期",
    statusColor: "#6B7280",
    statusBg: "#F3F4F6",
    insured: [
      { name: "林晓雨", idCard: "310***1234", phone: "138****8888", relation: "本人" },
      { name: "王美华", idCard: "310***8888", phone: "187****6666", relation: "朋友" },
    ],
    coverages: [
      { name: "行程取消", amount: "3,000元", desc: "因疾病、天气等原因取消行程" },
      { name: "行程中断", amount: "2,000元", desc: "行程中途因意外中断的损失" },
      { name: "延误补贴", amount: "每小时50元", desc: "交通延误超过3小时补贴" },
    ],
    claimContact: "95500",
    claimProcess: ["拨打理赔热线", "提交延误/取消证明", "48小时内审核", "5个工作日内赔付"],
    emergencyContact: "太平洋保险：95500",
  },
];

function PolicyDetailModal({ policy, onClose }: { policy: typeof policies[0]; onClose: () => void }) {
  const [activeTab, setActiveTab] = useState<"coverage" | "claim" | "insured">("coverage");

  return (
    <div className="fixed inset-0 z-50 flex flex-col" style={{ background: "#F7F7F7", fontFamily: "'SF Pro Text','PingFang SC',sans-serif" }}>
      {/* Header */}
      <div
        className="relative overflow-hidden flex-shrink-0"
        style={{ background: "linear-gradient(145deg,#064E3B 0%,#065F46 60%,#047857 100%)" }}
      >
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute rounded-full" style={{ width: 160, height: 160, top: -30, right: -10, background: "rgba(255,255,255,0.06)", filter: "blur(30px)" }} />
        </div>
        <div className="relative px-5 pb-5" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)" }}>
          <div className="flex items-center gap-3 mb-4">
            <button
              onClick={onClose}
              className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
              style={{ background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.15)" }}
            >
              <i className="ri-arrow-left-line" style={{ fontSize: 18, color: "#fff" }} />
            </button>
            <div className="flex items-center gap-2 flex-1">
              <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: "rgba(255,255,255,0.15)" }}>
                <i className="ri-shield-check-fill text-white" style={{ fontSize: 14 }} />
              </div>
              <div>
                <div className="text-sm font-bold text-white leading-tight">保险保单</div>
                <div className="text-xs leading-tight" style={{ color: "rgba(255,255,255,0.5)" }}>{policy.policyNo}</div>
              </div>
            </div>
            <span className="text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap"
              style={{ background: "rgba(255,255,255,0.12)", color: "#fff", border: "1px solid rgba(255,255,255,0.2)" }}>
              {policy.status}
            </span>
          </div>

          {/* Policy summary */}
          <div className="text-lg font-bold text-white mb-1">{policy.title}</div>
          <div className="text-sm mb-3" style={{ color: "rgba(255,255,255,0.65)" }}>{policy.insurer}</div>

          {/* Key info row */}
          <div className="flex gap-4">
            <div>
              <div className="text-xs mb-0.5" style={{ color: "rgba(255,255,255,0.5)" }}>保费</div>
              <div className="text-xl font-bold text-white">{policy.premium}</div>
            </div>
            <div className="w-px" style={{ background: "rgba(255,255,255,0.1)" }} />
            <div>
              <div className="text-xs mb-0.5" style={{ color: "rgba(255,255,255,0.5)" }}>保障期</div>
              <div className="text-sm font-semibold text-white">{policy.coveragePeriod}</div>
            </div>
          </div>
        </div>
        {/* Tabs */}
        <div className="flex px-5 gap-5" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
          {(["coverage", "claim", "insured"] as const).map((t) => {
            const labels = { coverage: "保障内容", claim: "理赔指南", insured: "被保险人" };
            return (
              <button
                key={t}
                onClick={() => setActiveTab(t)}
                className="py-3 text-sm cursor-pointer relative whitespace-nowrap flex-shrink-0 transition-colors"
                style={{ color: activeTab === t ? "#fff" : "rgba(255,255,255,0.45)", fontWeight: activeTab === t ? 700 : 400 }}
              >
                {labels[t]}
                {activeTab === t && <div className="absolute bottom-0 left-1/2 -translate-x-1/2 rounded-full" style={{ height: 2.5, width: 20, background: "#fff" }} />}
              </button>
            );
          })}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        {activeTab === "coverage" && (
          <div className="px-4 py-4 space-y-3">
            {policy.coverages.map((cov, i) => (
              <div key={i} className="rounded-2xl p-4" style={{ background: "#fff" }}>
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-center gap-3 flex-1">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: "#ECFDF5" }}>
                      <i className="ri-shield-check-line" style={{ color: "#10B981", fontSize: 20 }} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-bold text-gray-900">{cov.name}</div>
                      <div className="text-xs text-gray-400 mt-0.5 leading-relaxed">{cov.desc}</div>
                    </div>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <div className="text-xs text-gray-400 mb-0.5">保障额度</div>
                    <div className="text-base font-bold" style={{ color: "#10B981" }}>{cov.amount}</div>
                  </div>
                </div>
              </div>
            ))}
            {/* Emergency contact */}
            <div className="rounded-2xl p-4" style={{ background: "#ECFDF5", border: "1px solid #A7F3D0" }}>
              <div className="flex items-start gap-3">
                <i className="ri-phone-fill flex-shrink-0 mt-0.5" style={{ color: "#10B981", fontSize: 18 }} />
                <div>
                  <div className="text-sm font-bold text-green-800 mb-0.5">紧急救援热线</div>
                  <div className="text-xs text-green-700">{policy.emergencyContact}</div>
                  <div className="text-xs text-green-600 mt-0.5">7×24小时全天候服务</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "claim" && (
          <div className="px-4 py-4 space-y-3">
            <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
              <div className="text-sm font-bold text-gray-900 mb-3">理赔流程</div>
              <div className="space-y-3">
                {policy.claimProcess.map((step, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div
                      className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-white flex-shrink-0"
                      style={{ background: "#10B981" }}
                    >
                      {i + 1}
                    </div>
                    <div className="flex-1 pt-1 text-sm text-gray-700">{step}</div>
                    {i < policy.claimProcess.length - 1 && (
                      <div className="absolute" />
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
              <div className="text-sm font-bold text-gray-900 mb-3">理赔联系方式</div>
              <div className="flex items-center gap-3 p-3 rounded-xl" style={{ background: "#F0FDF4" }}>
                <div className="w-10 h-10 flex items-center justify-center rounded-xl" style={{ background: "#ECFDF5" }}>
                  <i className="ri-phone-line" style={{ color: "#10B981", fontSize: 20 }} />
                </div>
                <div>
                  <div className="text-xs text-gray-400">客服热线</div>
                  <div className="text-lg font-bold text-gray-900">{policy.claimContact}</div>
                </div>
              </div>
            </div>
            <div className="rounded-2xl p-4" style={{ background: "#FFFBEB" }}>
              <div className="flex items-start gap-2">
                <i className="ri-information-line flex-shrink-0 mt-0.5" style={{ color: "#F59E0B", fontSize: 15 }} />
                <div className="text-xs text-amber-700 leading-relaxed">
                  理赔申请需在事故发生后30天内提出。提交材料包括：证件照片、就医记录、费用发票等相关凭证。
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "insured" && (
          <div className="px-4 py-4 space-y-3">
            {policy.insured.map((person, i) => (
              <div key={i} className="rounded-2xl p-4" style={{ background: "#fff" }}>
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0"
                    style={{ background: "linear-gradient(135deg,#FF6B35,#FF9A5C)" }}>
                    {person.name[0]}
                  </div>
                  <div>
                    <div className="text-sm font-bold text-gray-900">{person.name}</div>
                    <div className="text-xs text-gray-400">{person.relation}</div>
                  </div>
                </div>
                <div className="space-y-2">
                  {[
                    { label: "证件号码", value: person.idCard },
                    { label: "联系电话", value: person.phone },
                  ].map(({ label, value }) => (
                    <div key={label} className="flex justify-between py-1.5" style={{ borderBottom: "1px solid #F8F8F8" }}>
                      <span className="text-xs text-gray-400">{label}</span>
                      <span className="text-sm font-medium text-gray-700">{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
            <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
              <div className="text-sm font-bold text-gray-900 mb-3">保单信息</div>
              <div className="space-y-2">
                {[
                  { label: "保单号", value: policy.policyNo },
                  { label: "承保公司", value: policy.insurer.slice(0, 12) + "..." },
                  { label: "投保日期", value: policy.purchaseDate },
                  { label: "保障期间", value: policy.coveragePeriod },
                  { label: "保费", value: policy.premium },
                ].map(({ label, value }) => (
                  <div key={label} className="flex justify-between py-1.5" style={{ borderBottom: "1px solid #F8F8F8" }}>
                    <span className="text-xs text-gray-400">{label}</span>
                    <span className="text-sm font-medium text-gray-700 text-right max-w-[60%]">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Bottom bar */}
      <div className="flex-shrink-0 bg-white px-5 py-4 flex gap-3" style={{ borderTop: "1px solid #F5F5F5" }}>
        <button
          className="flex-1 py-3 rounded-2xl text-sm font-semibold cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          style={{ background: "#F5F5F5", color: "#6B7280" }}
        >
          <i className="ri-download-2-line" style={{ fontSize: 15 }} />下载保单
        </button>
        {policy.status === "生效中" && (
          <button
            className="flex-1 py-3 rounded-2xl text-sm font-semibold text-white cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 active:scale-[0.98] transition-all"
            style={{ background: "linear-gradient(135deg,#10B981,#059669)" }}
          >
            <i className="ri-first-aid-kit-line" style={{ fontSize: 15 }} />申请理赔
          </button>
        )}
      </div>
    </div>
  );
}

export default function InsurancePage() {
  const navigate = useNavigate();
  const [selectedPolicy, setSelectedPolicy] = useState<typeof policies[0] | null>(null);

  if (selectedPolicy) {
    return <PolicyDetailModal policy={selectedPolicy} onClose={() => setSelectedPolicy(null)} />;
  }

  return (
    <div
      className="min-h-screen pb-10"
      style={{ background: "#F7F7F7", fontFamily: "'SF Pro Text','PingFang SC','Inter',system-ui,sans-serif" }}
    >
      {/* Header */}
      <div className="relative overflow-hidden" style={{ background: "linear-gradient(145deg,#064E3B 0%,#065F46 60%,#047857 100%)" }}>
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute rounded-full" style={{ width: 160, height: 160, top: -30, right: -10, background: "rgba(255,255,255,0.06)", filter: "blur(30px)" }} />
        </div>
        <div className="relative px-5 pb-5" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)" }}>
          <div className="flex items-center gap-3 mb-4">
            <button
              onClick={() => navigate(-1)}
              className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
              style={{ background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.15)" }}
            >
              <i className="ri-arrow-left-line" style={{ fontSize: 18, color: "#fff" }} />
            </button>
            <div className="flex items-center gap-2 flex-1">
              <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: "rgba(255,255,255,0.15)" }}>
                <i className="ri-shield-check-fill text-white" style={{ fontSize: 14 }} />
              </div>
              <div>
                <div className="text-base font-bold text-white leading-tight">保险保单</div>
                <div className="text-xs leading-tight" style={{ color: "rgba(255,255,255,0.5)" }}>行程安全保障</div>
              </div>
            </div>
          </div>
          {/* Stats */}
          <div className="flex gap-4">
            <div>
              <div className="text-2xl font-bold text-white">{policies.filter(p => p.status === "生效中").length}</div>
              <div className="text-xs" style={{ color: "rgba(255,255,255,0.5)" }}>生效中</div>
            </div>
            <div className="w-px" style={{ background: "rgba(255,255,255,0.1)" }} />
            <div>
              <div className="text-2xl font-bold text-white">{policies.length}</div>
              <div className="text-xs" style={{ color: "rgba(255,255,255,0.5)" }}>累计保单</div>
            </div>
          </div>
        </div>
      </div>

      {/* Policy list */}
      <div className="px-4 py-4 space-y-3">
        {policies.map((p) => (
          <div
            key={p.id}
            onClick={() => setSelectedPolicy(p)}
            className="rounded-2xl overflow-hidden cursor-pointer active:scale-[0.99] transition-all"
            style={{ background: "#fff" }}
          >
            {/* Top */}
            <div className="px-4 pt-4 pb-3" style={{ borderBottom: "1px solid #F5F5F7" }}>
              <div className="flex items-start justify-between gap-2 mb-2">
                <div className="flex items-center gap-2">
                  <div className="w-9 h-9 flex items-center justify-center rounded-xl" style={{ background: "#ECFDF5" }}>
                    <i className="ri-shield-check-line" style={{ color: "#10B981", fontSize: 18 }} />
                  </div>
                  <div>
                    <div className="text-sm font-bold text-gray-900">{p.title}</div>
                    <div className="text-xs text-gray-400 mt-0.5">{p.policyNo}</div>
                  </div>
                </div>
                <span className="text-xs font-semibold px-2.5 py-1 rounded-full flex-shrink-0" style={{ background: p.statusBg, color: p.statusColor }}>{p.status}</span>
              </div>
              <div className="flex items-center gap-3 text-xs text-gray-400">
                <span><i className="ri-file-list-line mr-1" style={{ fontSize: 11 }} />{p.order}</span>
                <span><i className="ri-calendar-line mr-1" style={{ fontSize: 11 }} />{p.coveragePeriod}</span>
              </div>
            </div>
            {/* Footer */}
            <div className="px-4 py-3 flex items-center justify-between">
              <div>
                <div className="text-xs text-gray-400 mb-0.5">保费</div>
                <div className="text-base font-bold text-gray-900">{p.premium}</div>
              </div>
              <div className="flex gap-2">
                {p.status === "生效中" && (
                  <button
                    onClick={(e) => { e.stopPropagation(); }}
                    className="px-3 py-1.5 rounded-full text-xs cursor-pointer whitespace-nowrap"
                    style={{ background: "#ECFDF5", color: "#10B981" }}
                  >
                    申请理赔
                  </button>
                )}
                <button
                  onClick={() => setSelectedPolicy(p)}
                  className="px-3 py-1.5 rounded-full text-xs font-semibold cursor-pointer whitespace-nowrap text-white active:scale-95 transition-all"
                  style={{ background: "linear-gradient(135deg,#10B981,#059669)" }}
                >
                  查看保单
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
